// src/components/store/sections/weekly-banner/WeeklyBannerV89CyberhologramOceanCyan.tsx
"use client";

import React from "react";
import DynamicWeeklyBannerVariant from "./DynamicWeeklyBannerVariant";

export default function WeeklyBannerV89CyberhologramOceanCyan(props: any) {
  return (
    <DynamicWeeklyBannerVariant
      variantNumber={89}
      archKey="cyber_hologram"
      archLabel="Cyber Neon Hologram"
      palName="OceanCyan"
      grad="from-cyan-500 via-sky-500 to-blue-700"
      lightBg="bg-cyan-50"
      textCol="text-cyan-700"
      borderCol="border-cyan-200"
      {...props}
    />
  );
}
